import { ComboBoxItemModel } from "@genexus/chameleon-controls-library/dist/types/components/combo-box/types";
import { ModuleServerType } from "../types";

export const mapTypesToComboboxItemModel = (
  types: ModuleServerType[]
): ComboBoxItemModel[] => {
  if (!types || !Array.isArray(types)) {
    return [];
  }
  const typesComboBoxItemModel: ComboBoxItemModel[] = [];
  types.forEach(type => {
    const typeObject: ComboBoxItemModel = {
      value: type.type,
      caption: type.type
    };
    typesComboBoxItemModel.push(typeObject);
  });
  return typesComboBoxItemModel;
};
